<template>
  <div>
      <div v-if="payload" @click="openModal" :class="{ flex: flexed }">
        <a v-if="show_message_button" class="button is-info" :style="{ 'font-size': message_button_font_size }">Message</a>
        <div v-else>
          <img v-if="payload.message == undefined || payload.message.trim().length == 0" class="btn" src="/edit_icon.svg" width="24px">
          <div v-else>
            <p class="custom_message" v-html="$sanitize(getMessage)"></p>
          </div>
          <p class="custom_message mt-5 is-size-7" v-html="$sanitize(autoMessage)"></p>
        </div>
        <div v-if="applicantKeyWord">
          <p>{{ payload.key_words }}</p>
        </div>
      </div>
      <AttributeDisplay
        v-if="show_attribute_form"
        :value="payload.salary_expectations_comment"
        :data="payload"
        title="Salary Expectations"
        requestName="updateApplicant"
        requestValue="salary_expectations_comment"
        classTitle="py-0 mt-5"
        classValue="py-0 m-0"
        horizantal
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import AttributeDisplay from '@/components/AttributeDisplay'
export default {
  name: 'message',
  props: {
    is_submitable: {
      type: Boolean,
      default: true
    },
    payload: {
      type: Object,
      default: () => {}
    },
    additional_data: {
      type: Object,
      default: () => {}
    },
    show_message_button: {
      type: Boolean,
      default: false
    },
    message_button_font_size: {
      type: String,
      default: ''
    },
    flexed: {
      default: false
    }
  },
  data () {
    return {
      show_attribute_form: false,
      time_helper: new TimeHelper()
    }
  },
  created () {
    this.show_attribute_form = this.additional_data ? this.additional_data.show_attribute_form : false
  },
  computed: {
    autoMessage () {
      return this.payload.auto_message || ''
    },
    getMessage () {
      let message = this.payload.message
      let extracted_message_date = this.getExtractedDateFromMessageMeta()
      if (extracted_message_date.length == 0) {
        return message
      }
      return message.replace(extracted_message_date, this.time_helper.makeTimeReadable(extracted_message_date) + ' ע"י ')
    },
    applicantKeyWord () {
      return this.additional_data ? this.additional_data.isShowKeyWord : false
    }
  },
  methods: {
    getExtractedDateFromMessageMeta () {
      return this.$utils.extractStringInsideHtmlTag(this.payload.message, 'message-date')
    },
    openModal () {
      if (!this.is_submitable) {
        return
      }
      this.create({
        designator: 'message-modal',
        component_name: 'MessageForm',
        resource_data: this.payload,
        additional_data: this.additional_data,
        is_submitable: true,
        modal_title: 'Message - ' + this.$utils.getResourceFullName({ resource_type: this.additional_data.resource_type, data: this.payload })
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    AttributeDisplay
  }
}
</script>
<style scoped>
.custom_message{
  margin: 0;
  text-align: right;
  white-space: pre-line;
}
.flex a {
  margin-left: 10px;
}
</style>
